import React, { useEffect, useState } from 'react'
import Dialog from '../ModalDialog'
import DialogContentText from '@mui/material/DialogContentText'
import PropTypes from 'prop-types'
import { TextField } from '@mui/material'
export default function AddSerialNumber({
  open,
  handleClose,
  updateSerialNumber,
  codeCourse,
  isLoadingActionOrder,
  errorActionCourse,
}) {
  const [serialNumber, setSerialNumber] = useState('')
  const [openDialogConfirmation, setOpenDialogConfirmation] = useState('')
  const [serialNumberError, setSerialNumberError] = useState(false)

  const handleConfirm = () => {
    if (!serialNumber.trim()) {
      setSerialNumberError(true)
      return
    }

    setSerialNumberError(false)
    setOpenDialogConfirmation(true)
  }
  useEffect(() => {
    if (errorActionCourse) {
      handleClose()
      setOpenDialogConfirmation(false)
    }
  }, [errorActionCourse])

  return (
    <>
      <Dialog
        maxWidthDialog={'sm'}
        open={open}
        title={'Ajout un Numéro de série'}
        style={{ display: openDialogConfirmation && 'none' }}
        content={
          <div
            style={{ paddingRight: '16px', paddingBottom: '16px', width: '530px' }}
          >
            <div style={{ paddingBottom: '5px' }}>
              <TextField
                id="nom-filter"
                variant="outlined"
                placeholder="Numéro de série"
                onChange={(event) => {
                  setSerialNumber(event.target.value)
                  if (event.target.value.trim()) {
                    setSerialNumberError(false)
                  }
                }}
                value={serialNumber}
                error={serialNumberError}
                helperText={
                  serialNumberError ? 'Le numéro de série est obligatoire' : ''
                }
              />
            </div>
          </div>
        }
        handleClose={handleClose}
        handleClickAction={handleConfirm}
      />
      <Dialog
        maxWidthDialog={'sm'}
        open={openDialogConfirmation}
        title={'Confirmation'}
        style={{ display: errorActionCourse && 'none' }}
        content={
          <DialogContentText sx={{ pr: 2, pb: 2 }}>
            {`Confirmez-vous l’ajout du numéro de série : ${serialNumber} ? Cette action est irréversible»`}
          </DialogContentText>
        }
        handleClose={() => {
          setOpenDialogConfirmation(false)
        }}
        handleClickAction={() => updateSerialNumber(codeCourse, serialNumber)}
        isLoadingButtonAction={isLoadingActionOrder}
      />
    </>
  )
}
AddSerialNumber.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  updateSerialNumber: PropTypes.func,
  codeCourse: PropTypes.string,
  isLoadingActionOrder: PropTypes.bool,
  errorActionCourse: PropTypes.string,
}
